// src/components/Navbar.jsx
import React from "react";
import { AppBar, Toolbar, Typography, Button, Box } from "@mui/material";

export default function Navbar() {
  const rol = localStorage.getItem("rol") || "Sin rol";

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("rol");
    localStorage.removeItem("empleado_id");
    window.location.href = "/login";
  };

  return (
    <AppBar position="sticky" elevation={1}>
      <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography variant="h6">Gestión RRHH – Olibru</Typography>
        <Box display="flex" gap={2} alignItems="center">
          <Typography variant="body2">Rol: {rol}</Typography>
          <Button color="inherit" onClick={logout}>Salir</Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
